import { render, staticRenderFns } from "./crownsOperateLog.vue?vue&type=template&id=195417fe&scoped=true&"
import script from "./crownsOperateLog.vue?vue&type=script&lang=js&"
export * from "./crownsOperateLog.vue?vue&type=script&lang=js&"
import style0 from "./crownsOperateLog.vue?vue&type=style&index=0&id=195417fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195417fe",
  null
  
)

export default component.exports